export const grammar = {
    uk: {
        header: "Граматика",
        listOfTopics: "Список тем"
    },
    en: {
        header: "Grammar",
        listOfTopics: "List of Topics"
    }
}